<template>
  <div v-if="isLoggedIn" class="page-wrapper">
    <div class="min-h-[80vh]">
      <div class="mt-20 text-center page-title text-primaryBlue">
        Thank you for participating
      </div>
      <div class="mb-40">
        <div class="py-10">
          <Vue3Lottie :animationData="Splash" :width="400" />
        </div>
        <br />
        <br />
        <br />
        <a
          href="/safalta-app/participants/logout"
          class="button-blue w-[300px] inline-block btn-block"
        >
          Logout
        </a>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { computed, onBeforeMount, onMounted } from 'vue'
import { Vue3Lottie } from 'vue3-lottie'
import Splash from '../assets/splash.json'
import Footer from '@/components/Footer.vue'

onMounted(() => {
  if (window.fbq) {
    fbq('track', 'CompleteRegistration')
  }
})

const isLoggedIn = computed(() => window?.safalta_config?.IS_LOGGED_IN)

onBeforeMount(() => {
  if (!isLoggedIn.value) {
    window.location.href = '/safalta-app/'
    return
  }
})
</script>
